import { Route } from '@/app/router'

const OrderOem = () => import('./index.vue')

export default new Route('/orders-oem/:id', OrderOem)
	.as('Dashboard:OrderOem')
	.permissions(['VIEW_OEM_ORDER', 'OEM_ENABLED'])
